import { combineReducers } from 'redux'
import DashboardLoader from '../dashboard/loader'
import ErrorLoader from '../errors/loader'
import EventLoader from '../monitor/events/loader'
import MonitorLoader from '../monitor/loader'
import SnapshotLoader from '../monitor/snapshot/loader'
import OperationLoader from '../operation/loader'
import ProfileListLoader from '../profile-list/loader'
import { ContextState } from '../redux/context/ContextState'
import { v2Reducer } from '../redux/V2/v2Reducer'
import TraceLoader from '../trace/loader'

const initialGlobalState = {}

// @ts-ignore
const reducer = (globalState: ContextState = initialGlobalState, action) => {
    // @ts-ignore
    if (!PRODUCTION && action.type && action.type.substr(0, 2) !== '@@') {
        // eslint-disable-next-line no-console
        console.groupCollapsed('%cRedux Action: %c%s', 'color: gray', 'color: darkblue', action.type)
        // eslint-disable-next-line no-console
        console.info(action)
        // eslint-disable-next-line no-console
        console.groupEnd()
    }

    switch (action.type) {
        case 'TIDEWAYS_INIT':
            return {
                ...globalState,
                ...action.tidewaysContext,
                router: action.router,
            }
        case 'TIDEWAYS_ROUTE': {
            const { route } = action

            let service = route.parameters.s

            if (!service || service.length === 0) {
                service = globalState.service
            }

            let environment = route.parameters.env

            if (!environment || environment.length === 0) {
                environment = globalState.environment
            }

            const elements = document.getElementsByTagName('html')

            if (elements.length === 1) {
                const html = elements[0]
                html.setAttribute('class', route.route)
            }

            return {
                ...globalState,
                route,
                service,
                environment,
            }
        }
    }

    return globalState
}

export default combineReducers({
    tidewaysContext: reducer,
    operations: OperationLoader.handleAction,
    traces: TraceLoader.handleAction,
    snapshots: SnapshotLoader.handleAction,
    events: EventLoader.handleAction,
    monitor: MonitorLoader.handleAction,
    profiles: ProfileListLoader.handleAction,
    dashboard: DashboardLoader.handleAction,
    errors: ErrorLoader.handleAction,
    v2: v2Reducer,
})
